import { ChangeEvent } from "react";
import React from 'react';
import { Form } from "react-bootstrap";



interface Option {
  label: string;
  value: string;
}

interface SelectProps {
  label?: string;
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  id?: string;
  name?: string;
  className?: string
}

export const Select: React.FC<SelectProps> = ({
  label,
  options,
  value,
  onChange,
  placeholder = "-- Select --",
  id,
  name,
  className=''
}: SelectProps) => {

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <>
      {label && 
      (  <Form.Label className="fw-bold">{label}:</Form.Label>)}
      
        <Form.Select value={value} onChange={handleChange} name={name} className={ className.concat(' btn btn-light my-2 text-truncate pe-5') } aria-label="Change Currency">
          <option value="">{placeholder}</option>
              {options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                  {opt.label}
          </option>
      ))}
        </Form.Select>
    
    </>
    
  );
}
